import { QUESTION_TYPES } from '@/utils/constants'

export const eachAnswerTypes = [
  QUESTION_TYPES.multiText,
  QUESTION_TYPES.multiNumber,
  QUESTION_TYPES.slider,
]

export const columnReferenceTypes = [
  QUESTION_TYPES.matrixRadio,
  QUESTION_TYPES.matrixCheckbox,
]
